export default "__VITE_ASSET__883b1667__"